/**
 * CCW kit questions at add to cart / on the product page (see snippets/ccw-kit-questions.liquid)
 *
 * Page questions: option-style choices, first answer preselected.
 * Add-to-cart questions: asked one after another when Add to Cart is tapped, once per
 * page, unless the vehicle finder's saved machine answers them.
 *
 * When every question has an answer, the kit line is stamped with the visible answers
 * plus _ccw_kit / _ccw_kit_notes for the checkout function.
 *
 * Runs in the capture phase ahead of the backorder prompt (its script tag comes first).
 * Answers are kept for the page, so when the backorder prompt stops a submit and
 * re-submits later, the kit properties are re-added on that pass too.
 *
 * A question with only_when (e.g. Kit Type: Wired) is skipped while another variant is selected.
 *
 * Debug: window.CCWKitQuestions.data() / .answers() / .reset()
 */
(function () {
  'use strict';

  var FORM_SELECTOR = 'form[data-type="add-to-cart-form"]';
  var answers = {};        // question handle -> answer handle, for add-to-cart questions
  var pendingForm = null;
  var pendingQuestion = null;

  function data() {
    var node = document.querySelector('[data-ccw-kit-data]');
    if (!node) return null;
    try { return JSON.parse(node.textContent); } catch (e) { return null; }
  }

  function safeGet(key) {
    try { return localStorage.getItem(key); } catch (e) { return null; }
  }

  function findAnswer(question, handle) {
    for (var i = 0; i < question.answers.length; i++) if (question.answers[i].handle === handle) return question.answers[i];
    return null;
  }

  /* Vehicle finder shortcut: only when the saved vehicle routes to this bundle. */
  function answerFromGarage(kit, question) {
    var year = parseInt(safeGet('ccw_garage_year'), 10);
    var route = safeGet('ccw_garage_route_url') || '';
    if (!year || !route) return null;
    var routePath = route.split('?')[0].replace(/\/$/, '');
    var productPath = (kit.productUrl || '').split('?')[0].replace(/\/$/, '');
    if (!productPath || routePath.slice(-productPath.length) !== productPath) return null;
    if (question.beforeYear && question.beforeYearAnswer && year < question.beforeYear) return question.beforeYearAnswer;
    if (question.fromYear && question.fromYearAnswer && year >= question.fromYear) return question.fromYearAnswer;
    return null;
  }

  /* only_when: ask only while the selected variant has that option value (e.g. Kit Type: Wired). */
  function selectedVariant(kit, form) {
    var input = form && form.querySelector('[name="id"]');
    return input && kit.variants ? kit.variants[String(input.value)] : null;
  }

  function applies(kit, question, form) {
    if (!question.onlyOption) return true;
    var options = selectedVariant(kit, form || document.querySelector(FORM_SELECTOR));
    return !options || options[question.onlyOption] === question.onlyValue;
  }

  function syncPageQuestions() {
    var kit = data();
    if (!kit || !kit.questions) return;
    kit.questions.forEach(function (question) {
      if (question.placement !== 'page') return;
      var block = document.querySelector('[data-ccw-kit-page-question="' + CSS.escape(question.handle) + '"]');
      if (block) block.hidden = !applies(kit, question);
    });
  }

  function pageAnswer(question) {
    var block = document.querySelector('[data-ccw-kit-page-question="' + CSS.escape(question.handle) + '"]');
    var selected = block && block.querySelector('[data-ccw-kit-page-answer][aria-checked="true"]');
    return selected ? selected.getAttribute('data-ccw-kit-page-answer') : (question.answers[0] && question.answers[0].handle);
  }

  function chosen(kit, question) {
    if (question.placement === 'page') return pageAnswer(question);
    if (!answers[question.handle]) {
      var auto = answerFromGarage(kit, question);
      if (auto && findAnswer(question, auto)) answers[question.handle] = auto;
    }
    return answers[question.handle] || null;
  }

  function stamp(form, kit) {
    var choices = {};
    var notes = [];
    var props = {};
    kit.questions.forEach(function (question) {
      if (!applies(kit, question, form)) return;
      var handle = chosen(kit, question);
      var answer = handle && findAnswer(question, handle);
      if (!answer) return;
      choices[question.handle] = answer.handle;
      props[question.label] = answer.value;
      notes.push([question.label, answer.value]);
    });
    props._ccw_kit = JSON.stringify(choices);
    props._ccw_kit_notes = JSON.stringify(notes);
    Object.keys(props).forEach(function (name) {
      var input = document.createElement('input');
      input.type = 'hidden';
      input.name = 'properties[' + name + ']';
      input.value = props[name];
      input.setAttribute('data-ccw-kit-prop', '');
      form.appendChild(input);
    });
    // The theme's product-form handler reads the form data synchronously during this
    // submit, so the inputs can come off on the next tick.
    setTimeout(function () {
      var added = form.querySelectorAll('[data-ccw-kit-prop]');
      for (var i = 0; i < added.length; i++) added[i].remove();
    }, 0);
  }

  function dialogFor(handle) {
    return document.querySelector('[data-ccw-kit-dialog="' + CSS.escape(handle) + '"]');
  }

  function resubmit(form) {
    if (typeof form.requestSubmit === 'function') form.requestSubmit();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  function closeAll() {
    var open = document.querySelectorAll('[data-ccw-kit-dialog][open]');
    for (var i = 0; i < open.length; i++) open[i].close();
    pendingForm = null;
    pendingQuestion = null;
  }

  function choose(handle) {
    var form = pendingForm;
    if (pendingQuestion) answers[pendingQuestion] = handle;
    closeAll();
    if (form) resubmit(form); // asks the next unanswered question, or adds to cart
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches(FORM_SELECTOR)) return;
    var kit = data();
    if (!kit || !kit.questions || !kit.questions.length) return;

    for (var i = 0; i < kit.questions.length; i++) {
      var question = kit.questions[i];
      if (question.placement === 'page' || !applies(kit, question, form) || chosen(kit, question)) continue;
      var dlg = dialogFor(question.handle);
      if (!dlg || typeof dlg.showModal !== 'function') continue;
      event.preventDefault();
      event.stopImmediatePropagation();
      pendingForm = form;
      pendingQuestion = question.handle;
      dlg.showModal();
      var first = dlg.querySelector('[data-ccw-kit-answer]');
      if (first) first.focus();
      return;
    }

    stamp(form, kit); // let the backorder prompt and the theme handler run
  }, true);

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t.closest) return;
    var choice = t.closest('[data-ccw-kit-answer]');
    if (choice) return choose(choice.getAttribute('data-ccw-kit-answer'));
    if (t.closest('[data-ccw-kit-cancel]')) return closeAll();
    if (t.matches && t.matches('[data-ccw-kit-dialog]')) return closeAll();

    var option = t.closest('[data-ccw-kit-page-answer]');
    if (option) {
      var group = option.closest('[data-ccw-kit-page-question]');
      var buttons = group.querySelectorAll('[data-ccw-kit-page-answer]');
      for (var i = 0; i < buttons.length; i++) {
        var on = buttons[i] === option;
        buttons[i].classList.toggle('is-selected', on);
        buttons[i].setAttribute('aria-checked', on ? 'true' : 'false');
      }
      var label = group.querySelector('[data-ccw-kit-selected]');
      if (label) label.textContent = option.getAttribute('data-ccw-kit-value') || '';
    }
  });

  document.addEventListener('close', function (event) {
    // The close event fires asynchronously: by then the next question's prompt may already
    // be open, so only clear state that belongs to the prompt that closed.
    if (event.target.matches && event.target.matches('[data-ccw-kit-dialog]') &&
        event.target.getAttribute('data-ccw-kit-dialog') === pendingQuestion && !event.target.open) {
      pendingForm = null;
      pendingQuestion = null;
    }
  }, true);

  // The theme swaps the variant id after an option change; re-check page questions once it has.
  document.addEventListener('change', function () { setTimeout(syncPageQuestions, 60); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncPageQuestions);
  else syncPageQuestions();

  window.CCWKitQuestions = {
    data: data,
    answers: function () { return answers; },
    reset: function () { answers = {}; }
  };
})();
